<style>
</style>

<template>
  <div>

    <div> 
      <form-question ref="question" v-for="state in statePath" :key="state" class="light-frame"  
        :question="questions[state.qid]"
        :values="values"
        :value="values[state.qid]"
        :error-message="errorMessage(state.qid)"
        @answer-value="nextState(state, $event)">
      </form-question>
    </div>


    <div v-if="transitionToScreen != null" class="centered-child">
      <md-button :disabled="loading" class="md-raised md-primary large-button" @click="onClickContinue()">Continue</md-button>

      <div v-if="hasError" style="color: red">Please correct the mistakes before </div>
    </div>


  </div>
</template>

<script>
import Question from './Question'
import ServiceAccess from '../service/ServiceAccess'


export default {
  components: {
    'form-question': Question
  },

  props: {
    sessionId: {
      type: String,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    questions: {
      type: Object,
      required: true
    },
    screens: {
      type: Object,
      required: true
    },
    errorMessages: {
      type: Object,
      required: true
    },
    screen: {
      type: Object,
      required: true
    }
  },

  watch: {
    screen: function (newVal, oldVal) {
      if (oldVal != null && newVal !== oldVal) {
        this.updateStatePath(newVal)
      }
    }
  },

  data: function () {
    return {
      statePath: [],
      transitionToScreen: null,
      hasError: false,
      loading: false
    }
  },


  created: function () {
    this.updateStatePath(this.screen)
  },

  methods: {
    errorMessage: function (qid) {
      if (this.errorMessages && this.questions) {
        let question = this.questions[qid]
        if (question && question.a) {
          return this.errorMessages[question.a.type]
        }
      }
      return null
    },

    updateStatePath: function (screen) {

      this.hasError = false
      

      let [statePath, transistionToScreenId] = this.screen.statePath(this.values)

      if (statePath == null && transistionToScreenId) {
        this.$emit('transition-to-next-screen', transistionToScreenId)
      } else {
        this.transitionToScreen = transistionToScreenId
        this.statePath = []
        this.$nextTick(() => { this.statePath = statePath })       
      }
    },

    currentState: function () {
      return
    },

    nextState: function (state, v) {
      // console.log('qid: ' + state.qid + ' - State ' + state.id + '  ->  ' + v)
      
      if (state.qid === 'id_crrv') { 
        ServiceAccess.instance.track(this.$route.params.sessionId, 'user-crrv', {value: v})
      } else if (state.qid === 'id_user_country') {
        let text = this.questions[state.qid].a.values[v].en
        this.values.id_user_adress_country = text
        ServiceAccess.instance.track(this.$route.params.sessionId, 'user-country', {country: text})
      } else if (state.qid === 'id_user_visacountry') {
        let text = this.questions[state.qid].a.values[v].en
        this.values.id_user_adress_country = text
        ServiceAccess.instance.track(this.$route.params.sessionId, 'user-country', {country: text})
      } else if (state.qid === 'id_why') {
        let text = this.questions[state.qid].a.values[v].en 
        ServiceAccess.instance.track(this.$route.params.sessionId, 'user-why', {why: text})
      } else if (state.qid === 'id_demande_visa' && v === true) {
        this.values.id_user_visacountry = this.values.id_user_country
      }

      // delete dependent values
      let oldVal = this.values[state.qid]
      if (oldVal !== v) {
        for (let dependentId of this.questions[state.qid].dependencies) {
          delete this.values[dependentId]
          let index = this.statePath.findIndex(s => s.qid === dependentId)
          if (index > 0) {
            this.$refs.question[index].reset()
          }
        }
      }

      this.values[state.qid] = v
      let [statePath, transistionToScreenId] = this.screen.statePath(this.values)
      
      if (statePath == null && transistionToScreenId) {
        this.$emit('transition-to-next-screen', transistionToScreenId)
      } else {
        this.transitionToScreen = transistionToScreenId
        this.statePath = statePath

        this.hasError = !this.statePath
          .filter(s => s.qid != null)
          .every(s => this.questions[s.qid].checkCondition(this.values[s.qid]), this.values)
      }
    },


    onPrevButton: function () {
      this.$emit('transition-to-prev-screen')
    },

    onClickContinue: function () {
      if (!this.hasError) {
        this.loading = true
        this.screen.onLeave(this.values, this.sessionId).then(res => {
          this.loading = false
          this.$emit('transition-to-next-screen', this.transitionToScreen)
        }, err => {
          this.loading = false
          console.error('Unable to leave screen, error: ', err)
        })
      }
    }


  }
}



</script>



// WEBPACK FOOTER //
// Screen.vue?cbde15fc